// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2xjIs","image":"Header_image__1v-YP","name":"Header_name__3J2a8","info":"Header_info__Wtwfd","infoRow":"Header_infoRow__284Tk"};